import React from "react";
import "./AboutSecond.css";

export default function AboutSecond() {
  const bgImage = `${process.env.PUBLIC_URL}/truck.jpg`;

  return (
    <section className="about-second">
      <div className="as-container">
        <div className="as-content-wrapper">
          {/* LEFT (desktop) / SECOND (mobile): TEXT */}
          <div className="as-text-content" aria-labelledby="as-title">
            <div className="as-headline-wrapper">
              <h1 id="as-title" className="as-headline" aria-label="Building Excellence In Every Structure">
                <span className="as-headline-line">MISSION &amp; CORE VALUES</span>
              </h1>
            </div>

            <div className="as-description">
              <p className="as-copy">
                At MNG Construction LLC, we are proud to be your trusted partner in heavy civil contracting! Our strong
                focus on safety, quality, efficiency, and effective management ensures we treat our customers,
                subcontractors, suppliers, and the public with the highest respect. We are committed to providing
                exceptional value to all our clients, including developers, municipalities, and general contractors. By
                adhering to these principles, MNG Construction has built a strong and successful presence in this dynamic
                industry. Let&apos;s build the future together.
              </p>

              {/* Optional feature chips container (auto-hides when empty) */}
              <div className="as-features" role="list" aria-label="Key qualities">
                {/* Example pills (remove if not needed)
                <span className="as-feature" role="listitem">
                  <span className="as-feature-dot" /> Safety-First
                </span>
                <span className="as-feature" role="listitem">
                  <span className="as-feature-dot" /> Quality Craftsmanship
                </span>
                <span className="as-feature" role="listitem">
                  <span className="as-feature-dot" /> On-Time Delivery
                </span>
                */}
              </div>

              <div className="as-actions">
                <a href="/contact" className="as-btn as-btn-primary">
                  <span>Start Your Project</span>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path
                      d="M5 12H19M19 12L12 5M19 12L12 19"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </a>

                <a href="/Projects" className="as-btn as-btn-secondary">
                  <span>Explore Portfolio</span>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path
                      d="M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z"
                      stroke="currentColor"
                      strokeWidth="2"
                    />
                    <path
                      d="M12 20c2.912 0 5.463-1.528 6.812-3.827.847-1.421.847-6.924 0-8.345C17.463 5.528 14.912 4 12 4S6.537 5.528 5.188 7.827c-.846 1.421-.846 6.924 0 8.345C6.537 18.472 9.088 20 12 20Z"
                      stroke="currentColor"
                      strokeWidth="2"
                    />
                  </svg>
                </a>
              </div>
            </div>
          </div>

          {/* RIGHT (desktop) / FIRST (mobile): IMAGE */}
          <div className="as-showcase-wrapper">
            <div
              className="as-showcase"
              style={{ backgroundImage: `url('${bgImage}')` }}
              role="img"
              aria-label="Construction site showcasing MNG Construction work"
            >
              <div className="as-showcase-overlay" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
